<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'Parameters',
  data() {
    return {
      startDateMenu: false,
      endDateMenu: false,
      firstDayOfWeek: 1,
      item: {
        start_date: null,
        end_date: null,
        end_time: null,
        start_time: null,
        granularity: 'day',
      },
      modelName: 'OilVolumeChange',
    }
  },
  computed: {
    startDateTime() {
      return (
        this.item.start_date +
        (this.item.granularity === 'day' ? '' : ' ' + this.item.start_time)
      )
    },
    endDateTime() {
      return (
        this.item.end_date +
        (this.item.granularity === 'day' ? '' : ' ' + this.item.end_time)
      )
    },
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    locale() {
      return this.$i18n.locale === 'ch' ? 'zh' : this.$i18n.locale
    },
  },
  watch: {
    'item.granularity': function(newVal, oldVal) {
      if (newVal === 'hour' || newVal === 'minute') {
        this.item.start_time = this.item.start_time || '00:00'
        this.item.end_time = this.item.end_time || '23:59'
      } else {
        this.item.start_time = null
        this.item.end_time = null
      }
    },
    'item.start_time': function(newVal, oldVal) {},
  },
  mounted() {
    this.firstDayOfWeek = this.unitsMeasurement.firstDayOfWeek
    let settingsFromStore = this.getSettingsFromStore()
    if (!settingsFromStore) {
      const endDate = moment(new Date()).format('YYYY-MM-DD')
      const startDate = moment(endDate, 'YYYY-MM-DD')
        .add(-1, 'month')
        .format('YYYY-MM-DD')
      this.item = {
        ...this.item,
        start_date: startDate,
        end_date: endDate,
      }
    } else {
      this.item = {
        ...settingsFromStore,
        start_date: moment(settingsFromStore.start_date).format('YYYY-MM-DD'),
        end_date: moment(settingsFromStore.end_date).format('YYYY-MM-DD'),
      }
    }
    this.confirm()
  },
  methods: {
    confirm() {
      if (
        !this.item.start_date ||
        !this.item.end_date ||
        !this.item.granularity
      )
        return
      this.setSettingsInStore()
      this.$emit('set-params', this.formatOutput())
    },
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.item),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
    formatOutput() {
      return {
        granularity: this.item.granularity,
        start_date:
          this.item.start_date +
          ' ' +
          (this.item.granularity === 'day' ? '00:00' : this.item.start_time),
        end_date:
          this.item.end_date +
          ' ' +
          (this.item.granularity === 'day'
            ? '23:59:59.999'
            : this.item.end_time),
      }
    },
    closeMenu(kind, isTime) {
      if (isTime || this.item.granularity === 'day') {
        if (kind === 'start') this.startDateMenu = false
        else if (kind === 'end') this.endDateMenu = false
      }
    },
  },
}
</script>

<template>
  <v-container
    fluid
    grid-list-xs
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        md3
        xs12
      >
        <div>
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            v-model="startDateMenu"
            :nude-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="startDateTime"
              :label="$t('label__start_date')"
              append-icon="event"
              readonly
            />
            <v-date-picker
              v-model="item.start_date"
              :max="item.end_date"
              :first-day-of-week="firstDayOfWeek"
              :locale="locale"
              class="datePicker"
              @input="closeMenu('start')"
            />
            <v-time-picker
              v-if="item.start_time"
              v-model="item.start_time"
              format="24hr"
              @change="closeMenu('start', true)"
              @input="item.start_time = $event"
            />
          </v-menu>
        </div>
      </v-flex>
      <v-flex
        md3
        xs12
      >
        <div>
          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            v-model="endDateMenu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="endDateTime"
              :label="$t('label__end_date')"
              append-icon="event"
              readonly
            />
            <v-date-picker
              v-model="item.end_date"
              :min="item.start_date"
              :first-day-of-week="firstDayOfWeek"
              :locale="locale"
              class="datePicker"
              @input="closeMenu('end')"
            />
            <v-time-picker
              v-if="item.end_time"
              v-model="item.end_time"
              format="24hr"
              @change="closeMenu('end',true)"
              @input="item.end_time = $event"/>
          </v-menu>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-flex
        md4
        xs12
      >
        <v-btn-toggle
          v-model="item.granularity"
          mandatory
        >
          <v-btn
            value="minute"
            flat
          >
            {{ $t('label__minute') }}
          </v-btn>
          <v-btn
            value="hour"
            flat
          >
            {{ $t('label__hour') }}
          </v-btn>
          <v-btn
            value="day"
            flat
          >
            {{ $t('label__day') }}
          </v-btn>

        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <v-flex
      md2
      xs12
    >
      <v-btn
        color="primary"
        block
        @click="confirm()"
      >
        {{ $t('buttons__apply') }}
      </v-btn>
    </v-flex>
  </v-container>
</template>
<style lang="scss" module>
@import '@design';
</style>
